import type { ReactNode } from 'react';

import { allowsEmergencyCallNotification, isAgencyFeatureVisible } from '@ngsos/portal-core/agency';

import { useAgencyConfiguration } from './AgencyConfigurationContext';

export type AgencyFeatureViewProps = {
  children?: ReactNode;
  whenEnabled?: ReactNode;
  whenDisabled?: ReactNode;
  emergencyCallNotification?: boolean;
};

export function AgencyFeatureView({
  children,
  whenEnabled,
  whenDisabled,
  emergencyCallNotification,
}: AgencyFeatureViewProps) {
  const agencyConfiguration = useAgencyConfiguration();

  const isVisible = isAgencyFeatureVisible(
    emergencyCallNotification,
    allowsEmergencyCallNotification(agencyConfiguration),
  );

  return isVisible ? <>{whenEnabled ?? children}</> : <>{whenDisabled}</>;
}
